import {
    CHANGE_ADVANCE_DISBURSEMENTS_TAB_STORE_SETTINGS, CLOSE_AD_MODAL, EDIT_ADVANCE_DISBURSEMENT,
    FAILED_TO_EDIT_ADVANCE_DISBURSEMENT, OPEN_AD_MODAL, RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
    RECEIVE_EDIT_ADVANCE_DISBURSEMENT
} from "../actions";

const defaultState = {
    isAdModalOpen: false,
    selectedAdStatus: '',
    failedToPatchMessage: '',
    successPatchMessage: null
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case RECEIVE_ADVANCE_DISBURSEMENT_BY_ID:
            let selectedAdStatus;
            try {
                selectedAdStatus = action.payload.body.disbursementStatusMachineName
            }
            catch (e){
                selectedAdStatus = '';
            }
            return {
                ...state,
                selectedAdStatus: selectedAdStatus
            };
        case EDIT_ADVANCE_DISBURSEMENT:
            return {
                ...state,
                failedToPatchMessage: ''
            };
        case RECEIVE_EDIT_ADVANCE_DISBURSEMENT:
            return {
                ...state,
                isAdModalOpen: false,
                selectedAdStatus: '',
                failedToPatchMessage: '',
                successPatchMessage: action.payload.body.canceled?
                    'Advance disbursement was cancelled successfully' :
                    'Advance disbursement was updated successfully'
            };
        case CLOSE_AD_MODAL:
            return {
                ...state,
                isAdModalOpen: false,
                selectedAdStatus: '',
                failedToPatchMessage: ''
            };
        case OPEN_AD_MODAL:
            return {
                ...state,
                isAdModalOpen: true,
                successPatchMessage: null
            };
        case CHANGE_ADVANCE_DISBURSEMENTS_TAB_STORE_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case '@@router/LOCATION_CHANGE': {
            return {
                ...defaultState
            }
        }
        default:
            return state
    }
}